// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"7ac3b89d","309":"94990d09","408":"ef7059cb"}[chunkId] + ".chunk.js";
};